import React from 'react';
import styled from 'styled-components';

export const MAIN_CONTENT_ID = 'main-content';

// Above the fixed Navbar (z-index: 35), so the link is not covered when focused
const StyledSkipLink = styled.a`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 40;
  padding: 0.75rem 1.5rem;
  background-color: ${(p) => p.theme.colors.primary.main};
  color: ${(p) => p.theme.colors.primary.onMain};
  border-radius: 0 0 0.5rem 0;
  transform: translateY(-100%);

  &:focus {
    transform: translateY(0);
    color: ${(p) => p.theme.colors.primary.onMain};
    outline: 2px solid ${(p) => p.theme.colors.primary.outline};
    outline-offset: -2px;
  }
`;

const FOCUSABLE_SELECTOR =
  'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

const isVisible = (element: HTMLElement): boolean => element.getClientRects().length > 0;

export const SkipLink = (): JSX.Element => {
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>): void => {
    event.preventDefault();
    const mainContent = document.getElementById(MAIN_CONTENT_ID);

    if (!mainContent) return;

    const focusableElements = mainContent.querySelectorAll<HTMLElement>(FOCUSABLE_SELECTOR);
    const firstFocusable = Array.from(focusableElements).find(isVisible);

    if (firstFocusable) {
      firstFocusable.focus();
      return;
    }

    mainContent.focus();
  };

  return (
    <StyledSkipLink href={`#${MAIN_CONTENT_ID}`} onClick={handleClick}>
      Skip to main content
    </StyledSkipLink>
  );
};
